const LABELS = {
  days: ["jour", "jours"],
  hours: ["heure", "heures"],
  minutes: ["minute", "minutes"],
  seconds: ["seconde", "secondes"],
}

const pad2 = (value) => String(value).padStart(2, "0")

const splitRemaining = (remainingSeconds) => ({
  days: Math.floor(remainingSeconds / 86400),
  hours: Math.floor((remainingSeconds % 86400) / 3600),
  minutes: Math.floor((remainingSeconds % 3600) / 60),
  seconds: remainingSeconds % 60,
})

const setUnit = (root, key, value, padded) => {
  const valueEl = root.querySelector(`[data-countdown-unit="${key}"]`)
  const labelEl = root.querySelector(`[data-countdown-label="${key}"]`)
  if (!valueEl) return

  const next = padded ? pad2(value) : String(value)
  if (valueEl.textContent !== next) {
    valueEl.textContent = next
    valueEl.classList.remove("is-tick")
    // Force reflow so the tick animation can replay.
    void valueEl.offsetWidth
    valueEl.classList.add("is-tick")
  }

  if (labelEl) {
    const [singular, plural] = LABELS[key]
    labelEl.textContent = value === 1 ? singular : plural
  }
}

const renderDial = (root, remainingSeconds) => {
  const parts = splitRemaining(remainingSeconds)
  setUnit(root, "days", parts.days, false)
  setUnit(root, "hours", parts.hours, true)
  setUnit(root, "minutes", parts.minutes, true)
  // Secondes optionnelles (absentes sur le tableau de bord).
  setUnit(root, "seconds", parts.seconds, true)
}

export const initBackofficeCountdown = () => {
  document.querySelectorAll("[data-countdown-to]").forEach((el) => {
    const targetMs = Date.parse(el.dataset.countdownTo)
    if (Number.isNaN(targetMs)) return

    if (el._countdownTimer) clearInterval(el._countdownTimer)

    const tick = () => {
      const remaining = Math.max(0, Math.floor((targetMs - Date.now()) / 1000))
      if (remaining <= 0) {
        el.remove()
        clearInterval(el._countdownTimer)
        return
      }
      renderDial(el, remaining)
    }

    tick()
    el._countdownTimer = setInterval(tick, 1000)
  })
}
